import { Component } from '@angular/core';
import { Router,ActivatedRoute,Event as RouterEvent, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { AuthService } from './shared/providers/auth.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'lodgingSystemApp';
  public showHeader:boolean = true;
  public showLoader:boolean = true;

  constructor(private router: Router, private activatedRoute: ActivatedRoute,private authService:AuthService) {
    this.router.events.subscribe((e : RouterEvent) => {
      this.navigationInterceptor(e);
    })
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showHeader = this.activatedRoute.firstChild.snapshot.data.showHeader !== false;
      }
    });
    // Check if token exist
    let authToken = localStorage.getItem('AuthToken');
    if(authToken) {
      this.authService.isUserAuthenticated(this.router.url);
    }
    
  }

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.showLoader = true;
    }
    if (event instanceof NavigationEnd) {
      this.showLoader = false;
      // Scroll to top
      window.scrollTo(0, 0);
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.showLoader = false;
    }
    if (event instanceof NavigationError) {
      this.showLoader = false;
    }
  }
}
